query GetCalendarInformationsQuery {
  websites {
    edges {
      node {
        id
        name
      }
    }
  }
  contests {
    edges {
      node {
        id
        title
      }
    }
  }
}
